//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*

/**
* The event state to show in clients.
*
* 
*  * SCHEDULED value: SCHEDULED - EventScheduled: The event is scheduled to happen. This value is the default status for events. 
*  * RESCHEDULED value: RESCHEDULED - EventRescheduled: The event has been rescheduled to a later date. 
*  * POSTPONED value: POSTPONED - EventPostponed: The event has been postponed to a later date, but the date isn&#39;t known yet. 
*  * MOVED_ONLINE value: MOVED_ONLINE - EventMovedOnline: Indicates that the event was changed to allow online participation. 
*  * CANCELLED value: CANCELLED - EventCancelled: The event has been canceled. 
*/
@Serializable
enum class EventState(val value: kotlin.String) {

    @SerialName(value = "SCHEDULED")
    SCHEDULED("SCHEDULED"),

    @SerialName(value = "RESCHEDULED")
    RESCHEDULED("RESCHEDULED"),

    @SerialName(value = "POSTPONED")
    POSTPONED("POSTPONED"),

    @SerialName(value = "MOVED_ONLINE")
    MOVED_ONLINE("MOVED_ONLINE"),

    @SerialName(value = "CANCELLED")
    CANCELLED("CANCELLED");

  /**
  * Override [toString()] to avoid using the enum variable name as the value, and instead use
  * the actual value defined in the API spec file.
  *
  * This solves a problem when the variable name and its value are different, and ensures that
  * the client sends the correct enum values to the server always.
  */
  override fun toString(): kotlin.String = value

  companion object {
    /**
    * Converts the provided [data] to a [String] on success, null otherwise.
    */
    fun encode(data: kotlin.Any?): kotlin.String? = if (data is EventState) "$data" else null

    /**
    * Returns a valid [EventState] for [data], null otherwise.
    */
    fun decode(data: kotlin.Any?): EventState? = data?.let {
      val normalizedData = "$it".lowercase()
      values().firstOrNull { value ->
        it == value || normalizedData == "$value".lowercase()
      }
    }
  }
}

